module.exports = __webpack_public_path__ + "static/media/7x7BadOptimized.d998e2b0.png";